<template>
  <el-dialog
    :visible="visible"
    :width="isMobile ? '95%' : '70%'"
    :close-on-click-modal="false"
    class="emd-modal"
    @close="beforeClose"
  >
    <loader-wrapper :loading="loading">
      <template v-if="!curUser">
        <div class="title">СОЗДАНИЕ ПОЛЬЗОВАТЕЛЯ ЭДО</div>
        <check-inn @check="checkINN" />
        <p v-if="error && !contragent" class="edm-err">{{ error }}</p>
      </template>
      <template v-if="contragent">
        <edm-user-info :user="curUser" :contragent="contragent" />
        <check-user v-if="!curUser" @create="edsHandler" @failed="onFailed" />
        <issue-eds
          v-if="created || (curUser && !curUser.user_by_api_id)"
          :phone="curUser ? curUser.phone : phone"
          :org-id="
            curUser ? curUser.organization_id : +contragent.org_id_by_inn
          "
          :user="curUser"
          :issued="issued"
          @issue="edsHandler"
          @check="checkEDS"
          @download="edsDownload"
        />
        <eds-public-key
          v-if="curUser && (curUser.user_by_api_id || issued)"
          :user="curUser"
          @issue="edsHandler"
          @download="edsDownload"
        />
      </template>
    </loader-wrapper>
  </el-dialog>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'
import CheckInn from './CheckInn'
import CheckUser from './CheckUser'
import EdmUserInfo from './EdmUserInfo'
import EdsPublicKey from './EdsPublicKey'
import IssueEds from './IssueEds'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

const EdmUsers = RepositoryFactory.get('edmUsers')
const Contragents = RepositoryFactory.get('contragents')
const Doc = RepositoryFactory.get('document')

export default {
  name: 'EdmUserModal',
  components: {
    LoaderWrapper,
    CheckInn,
    CheckUser,
    IssueEds,
    EdmUserInfo,
    EdsPublicKey,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      curUser: null,
      contragent: null,
      loading: false,
      created: false,
      issued: false,
      phone: '',
      error: '',
      rules: [
        {
          required: true,
          message: 'Телефон обязателен для заполнения',
          trigger: 'blur',
        },
        { min: 18, message: 'Телефон заполнен не полностью', trigger: 'blur' },
      ],
    }
  },
  watch: {
    user: {
      immediate: true,
      handler(val) {
        if (val) {
          this.checkINN(val.org_inn)
          this.curUser = val
        }
      },
    },
  },
  methods: {
    beforeClose() {
      if (this.created || this.issued) {
        this.$store.dispatch('edmUsers/fetchUsers')
      }
      this.$emit('close')
      this.resetFields()
    },
    resetFields() {
      this.curUser = null
      this.contragent = null
      this.created = false
      this.issued = false
      this.phone = ''
      this.error = ''
    },
    checkINN(inn) {
      this.loading = true
      this.error = ''
      this.contragent = null
      this.created = false
      Contragents.findContragentsByInn(inn)
        .then(res => {
          const { status, data } = res

          if (status === 200 && data && data.items.length) {
            this.checkContract(data.items[0])
          } else {
            this.error =
              'Сообщите что водитель не зарегистрирован в системе. Помогите зарегистироваться.'
          }
        })
        .catch(e => this.errHandler(e))
        .finally(() => (this.loading = false))
    },
    checkContract(data) {
      const { contract, documents } = data
      const id = contract ? contract.document_id : null
      let doc = null

      if (id && documents && documents.length) {
        doc = documents.filter(d => d.id === id)
      }
      if (!doc || !doc.length || !doc[0].number) {
        // || !doc[0].document_create_date
        this.error = 'С водителем нет номера договора. Позвоните менеджеру.'
      } else {
        this.contragent = { ...data, docNumber: doc[0].number }
      }
    },
    edsHandler(phone, send = 1, download = 1) {
      const { org_id_by_inn: organization_id } = this.contragent

      if (phone && organization_id) {
        const settings = { phone, organization_id }

        if (send) {
          settings.resend_sms = 1
        }
        const action = 'virtual-signature/create-user'
        const path = Doc.getReportLink(action, settings)

        if (download) {
          this.downloadRegistry({ path })

          if (!this.curUser) {
            this.phone = phone
            this.created = true
          }
        } else {
          EdmUsers.sendSms(url)
            .then(res => {
              if (res.status === 200) {
                this.$message.success('СМС повторно отправлено')
              }
            })
            .catch(e => this.errHandler(e))
        }
      }
    },
    checkEDS(phone, organization_id) {
      EdmUsers.getList({ phone, organization_id })
        .then(res => {
          const { status, data } = res

          if (status === 200 && data && data.length && data[0].user_by_api_id) {
            this.edsDownload(phone)
            this.issued = true
          }
        })
        .catch(e => this.errHandler(e))
    },
    edsDownload(phone) {
      const { org_id_by_inn: organization_id } = this.contragent

      if (phone && organization_id) {
        const action = 'virtual-signature/print-user-dogovor'
        const settings = { phone, organization_id }
        const path = Doc.getReportLink(action, settings)

        this.downloadRegistry({ path })
      }
    },
    onFailed() {
      this.created = false
      this.phone = ''
    },
  },
}
</script>

<style lang="sass">
.emd-modal
  .el-dialog__body
    font-size: 16px
    line-height: 20px
    color: #000
    padding: 50px
    min-height: 450px
  .title
    color: #000
    font-weight: bold
    margin-top: 20px
    &.green
      color: #67C23A;
    p
     margin-top: 0
  .edm-row
    margin-top: 25px
    .title
      margin: 0
      &.width170
        width: 170px
        margin-bottom: 30px
    .el-form-item
      margin-bottom: 0
  .edm-50
    width: 50%
  .el-form
    margin-bottom: 35px;
  .edm-contr
    margin-left: 20px
    p
      margin: 0
      line-height: 20px
      .doc-phone
        font-size: 16px;
        border: none;
        outline: none;
  .edm-btn
    width: 100%
  .edm-err
    color: red
</style>
